import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/deprecate.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm deprecate <package-spec> <message>
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/deprecate.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <p>{`Note: This command is unaware of workspaces.`}</p>
    <h3>{`Description`}</h3>
    <p>{`This command will update the npm registry entry for a package, providing a
deprecation warning to all who attempt to install it.`}</p>
    <p>{`It works on `}<a parentName="p" {...{
        "href": "https://semver.npmjs.com/"
      }}>{`version ranges`}</a>{` as well as specific
versions, so you can do something like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm deprecate my-thing@"< 0.2.3" "critical bug fixed in v0.2.3"
`}</code></pre>
    <p>{`SemVer ranges passed to this command are interpreted such that they `}<em parentName="p">{`do`}</em>{`
include prerelease versions.  For example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm deprecate my-thing@1.x "1.x is no longer supported"
`}</code></pre>
    <p>{`In this case, a version `}<inlineCode parentName="p">{`my-thing@1.0.0-beta.0`}</inlineCode>{` will also be deprecated.`}</p>
    <p>{`You must be the package owner to deprecate something.  See the `}<inlineCode parentName="p">{`owner`}</inlineCode>{` and
`}<inlineCode parentName="p">{`adduser`}</inlineCode>{` help topics.`}</p>
    <p>{`To un-deprecate a package, specify an empty string (`}<inlineCode parentName="p">{`""`}</inlineCode>{`) for the `}<inlineCode parentName="p">{`message`}</inlineCode>{`
argument. Note that you must use double quotes with no space between them to
format an empty string.`}</p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`registry`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: "`}<a parentName="li" {...{
          "href": "https://registry.npmjs.org/%22"
        }}>{`https://registry.npmjs.org/"`}</a></li>
      <li parentName="ul">{`Type: URL`}</li>
    </ul>
    <p>{`The base URL of the npm registry.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`otp`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or String`}</li>
    </ul>
    <p>{`This is a one-time password from a two-factor authenticator. It's needed
when publishing or changing package permissions with `}<inlineCode parentName="p">{`npm access`}</inlineCode>{`.`}</p>
    <p>{`If not set, and a registry response fails with a challenge for a one-time
password, npm will prompt on the command line for one.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/package-spec"
        }}>{`package spec`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-publish"
        }}>{`npm publish`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/registry"
        }}>{`npm registry`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-owner"
        }}>{`npm owner`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-adduser"
        }}>{`npm adduser`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      